import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import * as $ from 'jquery';

@Component({
  selector: 'cli-yes-cancel-modal',
  templateUrl: './yes-cancel-modal.component.html',
  styleUrls: ['./yes-cancel-modal.component.scss']
})

export class YesCancelModalComponent implements OnInit {

  private subject: Subject<string>;

  @Input()
  public id: string;
  @Input()
  public message: string = '';
  @Input()
  public header: string;

  @Input()
  public okcaption = 'Yes';

  @Input()
  public isCancelShown = true;


  constructor() {

    this.header = environment.MODAL_HEADER;
  }

  ngOnInit() {
  }

  public openModal(): Observable<string> {

    $('#' + this.id).modal();
    this.subject = new Subject<string>();

    return this.subject.asObservable();
  }

  public proceedYes() {
    this.closeModal();

    this.subject.next('Yes');
    this.subject.complete();
  }

  public proceedCancel() {
    this.closeModal();

    this.subject.next('Cancel');
    this.subject.complete();
  }

  public closeModal() {
    $('#' + this.id).modal('hide');
  }

}
